/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_Uptime_BodyInputs */

const tr_mesafeli_s12_uptime_body = /** @type {(inputs: Mesafeli_S12_Uptime_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aylık %99,5 uptime hedefi (planlı bakım ve mücbir sebepler hariç).`)
};

const en_mesafeli_s12_uptime_body = /** @type {(inputs: Mesafeli_S12_Uptime_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`monthly uptime target of 99.5% (excluding planned maintenance and force majeure).`)
};

const de_mesafeli_s12_uptime_body = /** @type {(inputs: Mesafeli_S12_Uptime_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`monatliches Uptime-Ziel von 99,5 % (ausgenommen geplante Wartung und höhere Gewalt).`)
};

const ru_mesafeli_s12_uptime_body = /** @type {(inputs: Mesafeli_S12_Uptime_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`целевой показатель аптайма 99,5 % в месяц (за исключением плановых работ и обстоятельств непреодолимой силы).`)
};

/**
* | output |
* | --- |
* | "monthly uptime target of 99.5% (excluding planned maintenance and force majeure)." |
*
* @param {Mesafeli_S12_Uptime_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_uptime_body = /** @type {((inputs?: Mesafeli_S12_Uptime_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_Uptime_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_uptime_body(inputs)
	if (locale === "de") return de_mesafeli_s12_uptime_body(inputs)
	if (locale === "ru") return ru_mesafeli_s12_uptime_body(inputs)
	return tr_mesafeli_s12_uptime_body(inputs)
});